import { z } from 'zod';
import { fileSchema } from '../files/list';

const metadataSchema = z.object({
  operationId: z.string().nullable().optional(),
  model: z.string().nullable().optional(),
  aspectRatio: z.string().nullable().optional(),
  durationSeconds: z.string().nullable().optional(),
  negativePrompt: z.string().nullable().optional(),
  resolution: z.string().nullable().optional(),
  veo: z.any().nullable().optional(),
  image_id: z.string().nullable().optional(),
  veo_error: z.string().nullable().optional(),
  lastFrameId: z.string().nullable().optional(),
  /** ISO timestamp when a cron marked the job failed after sitting in a non-terminal state */
  staleResetAt: z.string().optional(),
  heygen: z.any().nullable().optional(),
  heygen_session_id: z.string().nullable().optional(),
  heygen_video_id: z.string().nullable().optional(),
  heygen_error: z.string().nullable().optional(),
});

export type AiVideoMetadata = z.infer<typeof metadataSchema>;

export const aiVideoSchema = z.object({
  id: z.string(),
  agencyId: z.string(),
  userId: z.string(),
  clientId: z.string().nullable(),
  prompt: z.string().nullable(),
  metadata: metadataSchema.nullable().optional(),
  status: z.string(),
  provider: z.string().nullable().optional(),
  fileId: z.string().nullable().optional(),
  file: fileSchema.nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type AiVideoSchema = z.infer<typeof aiVideoSchema>;
